import PropTypes from 'prop-types';

import { Button } from '@spotahome/ui-library';

import './CallToAction.scss';

const noop = () => {};

const CallToAction = ({
  href,
  text,
  onClick = noop,
  className = '',
  color = 'primary',
  dataTest = 'generic-call-to-action'
}) => (
  <Button
    href={href}
    color={color}
    className={`call-to-action ${className || ''}`}
    target="_blank"
    size="big"
    onClick={onClick}
    data-test={dataTest}
  >
    {text}
  </Button>
);

CallToAction.propTypes = {
  href: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  color: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  dataTest: PropTypes.string
};

export default CallToAction;
